import { RouteObject } from "react-router-dom";

import { MobileAnalyticsRoutes } from "./mobileAnalyticsRoutes";

export const MobileRoutes: RouteObject[] = [...MobileAnalyticsRoutes];
